import { render, staticRenderFns } from "./dishonesty-name.vue?vue&type=template&id=f12361d2&scoped=true&"
import script from "./dishonesty-name.vue?vue&type=script&lang=js&"
export * from "./dishonesty-name.vue?vue&type=script&lang=js&"
import style0 from "./dishonesty-name.vue?vue&type=style&index=0&id=f12361d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12361d2",
  null
  
)

export default component.exports